import { Component } from '@verndale/core';
import breakpoints from '../utils/breakpoints';

class ShowMoreItems extends Component {
  setupDefaults() {
    this.dom = {
      $items: this.el._$$('.more-items__item'),
      $lessButton: this.el._$('.more-items__button--less'),
      $moreButton: this.el._$('.more-items__button--more')
    };

    this.showAllOnLgFalse = this.el.dataset?.showAllOnLg === 'false';
    this.itemLimit = this.el.dataset?.itemLimit ?? this.dom.$items.length;

    this.hideItems();
  }

  addListeners() {
    const { $lessButton, $moreButton } = this.dom;

    $lessButton._on('click', ::this.hideItems);
    $moreButton._on('click', ::this.showItems);

    if (!this.showAllOnLgFalse) {
      breakpoints.addBreakpointListenerLg(::this.hideItems);
    }
  }

  showItems() {
    const { $items, $moreButton, $lessButton } = this.dom;
    $items.forEach(($item) => ($item.style.display = ''));

    $moreButton.style.display = 'none';

    if (this.dom.$items.length <= this.itemLimit) {
      $lessButton.style.display = 'none';
    } else {
      $lessButton.style.display = '';
    }
  }

  hideItems() {
    const { $items, $lessButton, $moreButton } = this.dom;

    if (
      (!this.showAllOnLgFalse && breakpoints.isLg()) ||
      this.dom.$items.length <= this.itemLimit
    ) {
      return this.showItems();
    }

    $items
      .filter(($item, index) => index >= this.itemLimit)
      .forEach(($item) => ($item.style.display = 'none'));

    $moreButton.style.display = '';
    $lessButton.style.display = 'none';
  }
}

export default ShowMoreItems;
